import React from 'react';
import { Button } from '@ps-design-system/components/Button';
import useCalendarSyncFlowStore from '../../../store/sync-flow/useCalendarSyncFlowStore';
import useSyncFlowNav, { NavSteps } from '../../hooks/useSyncFlowNav';
import CalSelectDialogContinueButtonStrings, { ButtonTextMap } from './strings';
import useSyncFlowAnalytics from '../../hooks/useSyncFlowAnalytics';

const CalSelectDialogContinueButton = () => {
  const isConnectingCal = useCalendarSyncFlowStore((state) => state.isConnectingCal);

  const { TrackContinueClicked } = useSyncFlowAnalytics();

  const {
    currentStep,
    navToNextStep,
    canNav
  } = useSyncFlowNav();

  const handleNav = () => {
    TrackContinueClicked();
    navToNextStep();
  };

  const shouldUsePurple =
    currentStep === NavSteps.SELECT_CALENDAR || currentStep === NavSteps.I_CALENDAR;

  return (
    <Button
      disabled={!canNav()}
      appearance={shouldUsePurple ? 'purple' : 'black'}
      className="CalSyncActionButtons_button"
      showSpinner={canNav() && isConnectingCal}
      onClick={handleNav}> {ButtonTextMap[currentStep] || CalSelectDialogContinueButtonStrings.continueButton}
    </Button>
  );
};

export default CalSelectDialogContinueButton;
